import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const CartsComponent = React.lazy(() => import("../Components/RootComponents/CartsComponent"));
const CartsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <CartsComponent />
      </Suspense>
    </Fragment>
  );
};

export default CartsPage;
